import { Box } from "@mui/material";

import CheckboxColumn from "components/Table/CheckboxColumn";
import { SolidButton as SolidRectangleButton } from "components/buttons/SolidRectangleButton";
import StatusTag from "components/StatusTag";

import EllipsisTooltipCell from "../EllipsisTooltipCell";

import { DEVICE_TYPE, DEVICE_STATUS_TAG, STATUS_TAG_LABEL } from "const";
import { SEVERITY_LEVEL, EVENTS_LOG_EVENTS_TYPE, EVENTS_LOG, EVENTS_LOG_MAP } from "const/eventsLog";

import { getEventMessageText } from "../helper"

import { formatTimestampByToday } from "utils/format";
import getEventsLogMessage from "utils/getEventsLogMessage";

const allEventsColumns = (
  columnHelper,
  permissions,
  setDrawerOpen,
  setDrawerData,
  isMspScope = false,
  onAcknowledgeEvent,
  {
    enableSelection = !isMspScope,
    showAcknowledgeAction = isMspScope,
    getRowDisabled,
  } = {},
) =>
  [
    enableSelection && permissions &&
    (permissions === "Admin" || permissions === "Super Admin") &&
    CheckboxColumn(columnHelper, null, {
      getRowDisabled: getRowDisabled ?? ((row) => row.acknowledge === true),
    }),
    columnHelper.accessor(
      row => SEVERITY_LEVEL[row.severity],
      {
        id: "severity",
        header: "Severity",
        cell: (info) => (
          <StatusTag
            status={info.getValue()}
            statusMapping={DEVICE_STATUS_TAG}
            labelMapping={STATUS_TAG_LABEL}
          />
        ),
      }
    ),
    columnHelper.accessor("createdAt", {
      header: "Time",
      cell: (info) => <Box>{formatTimestampByToday(info.getValue()) ?? "-"}</Box>,
      meta: {
        exportValue: ({ row }) => formatTimestampByToday(row.original.createdAt, 'export')
      }
    }),
    isMspScope && columnHelper.accessor("belongToMspName", {
      header: "MSP",
      cell: info => <Box>{info.getValue() ?? "-"}</Box>,
    }),
    isMspScope && columnHelper.accessor("orgName", {
      header: "Organization",
      cell: info => <Box>{info.getValue() ?? "-"}</Box>,
    }),
    columnHelper.accessor("siteName",
      {
        id: "siteName",
        header: "Site",
        cell: info => <Box>{info.getValue()}</Box>,
      }
    ),
    columnHelper.accessor(
      row => isMspScope
        ? (row.eventType === "SYSTEM_AUDIT" ? "System Audit" : "Device")
        : (EVENTS_LOG_EVENTS_TYPE[row.eventType] ?? row.eventType ?? "-"),
      {
        id: "eventType",
        header: "Event Type",
        cell: info => <Box>{info.getValue()}</Box>,
        meta: {
          exportValue: ({ row }) => isMspScope
            ? (row.original.eventType === "SYSTEM_AUDIT" ? "System Audit" : "Device")
            : (EVENTS_LOG_EVENTS_TYPE[row.original.eventType] ?? row.original.eventType ?? "-")
        }
      }
    ),
    columnHelper.accessor(row => (row.deviceType === "nc" ? "Switch" : DEVICE_TYPE[row.deviceType]) ?? "-",
      {
        id: "deviceType",
        header: "Device Type",
        cell: info => <Box>{info.getValue()}</Box>,
      }
    ),
    columnHelper.accessor("deviceName", {
      header: "Device Name",
      cell: (info) => <Box>{info.getValue() ?? "-"}</Box>,
    }),
    columnHelper.accessor("deviceMacAddress", {
      header: "Mac Address",
      cell: (info) => <Box>{info.getValue() ?? "-"}</Box>,
    }),
    columnHelper.accessor(
      (row) => getEventsLogMessage(row, EVENTS_LOG, EVENTS_LOG_MAP),
      {
        id: "description",
        header: "Description",
        cell: (info) => <EllipsisTooltipCell
          text={info.getValue()}
          rowData={info.row.original}
          setDrawerOpen={setDrawerOpen}
          setDrawerData={setDrawerData}
        />,
        meta: {
          exportValue: ({ row }) => getEventMessageText(row.original, EVENTS_LOG, EVENTS_LOG_MAP)
        }
      }
    ),
    columnHelper.accessor(
      row => row.payload.username ?? "-",
      {
        id: "clientName",
        header: "Client Name",
        cell: info => <Box>{info.getValue()}</Box>,
      }
    ),
    columnHelper.accessor(
      row => row.payload.macAddress ?? "-",
      {
        id: "clientMacAddress",
        header: "Client MAC Address",
        cell: info => <Box>{info.getValue()}</Box>,
      }
    ),
    showAcknowledgeAction && columnHelper.display({
      id: "actions",
      header: "Actions",
      enableSorting: false,
      cell: ({ row }) => {
        const isAcknowledged = row.original.acknowledge === true;

        return (
          <SolidRectangleButton
            width="118px"
            height="28px"
            disabled={isAcknowledged || !permissions}
            onClick={() => onAcknowledgeEvent?.(row.original.id)}
          >
            {isAcknowledged ? "Unmute" : "Mute"}
          </SolidRectangleButton>
        );
      },
    }),
  ].filter(Boolean);

export default allEventsColumns;
